import { createContext, useContext } from "react";

import type { StudioDirectory } from "./useStudioDirectory";

/**
 * The admin-only Studio directory (agency names, creator e-mails) of one list,
 * loaded once and shared with its cells (B6.3). Null outside a provider or for
 * non-admins' lists: the cells then fall back to "Studio film" / "Portal user …".
 */
export const StudioDirectoryContext = createContext<StudioDirectory | null>(
  null,
);

export const useStudioDirectoryContext = () =>
  useContext(StudioDirectoryContext);
